<div id="login" fxLayout="column">

    <div id="login-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

        <div id="login-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

            <div class="logo">
                <!-- <img src="assets/images/logos/fuse.svg"> -->
                <img src="assets/images/logos/ypm_trans.png" >
            </div>

            <div class="title">INGRESAR</div>

            <form name="loginForm" [formGroup]="loginForm" novalidate (ngSubmit)="onSubmit()">

                <mat-form-field appearance="outline">
                    <mat-label>Usuario</mat-label>
                    <input matInput formControlName="user">
                    <mat-icon matSuffix class="secondary-text">person</mat-icon>
                    <mat-error *ngIf="loginForm.get('user').hasError('required')">
                        Es requerido ingresar usuario
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Clave</mat-label>
                    <input matInput type="password" formControlName="password">
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                    <mat-error>
                        Es requerido ingresar clave
                    </mat-error>
                </mat-form-field>

                <button mat-raised-button color="accent" class="submit-button" aria-label="LOG IN"
                        [disabled]="loginForm.invalid">
                    INGRESAR
                </button>

            </form>


        </div>

    </div>

</div>
